import { c as createCommonjsModule, g as getDefaultExportFromCjs, a as commonjsGlobal } from './common/_commonjsHelpers-8c19dec8.js';

var constants = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
var STATES = {
    1: "CONNECTING",
    2: "OPEN",
    3: "CLOSING",
    4: "CLOSED"
};
exports.STATES = STATES;
var BINARY_TYPES = {
    blob: "blob",
    arraybuffer: "arraybuffer"
};
exports.BINARY_TYPES = BINARY_TYPES;
});

var dist = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });

var WebSocketClient = /** @class */ (function () {
    function WebSocketClient(url, protocols, options) {
        var _this = this;
        this.options = {
            shouldReconnect: true,
            reconnectRetryTimeout: 1000,
            parsedMessage: true,
            debug: false
        };
        this.shouldClose = false;
        this.shouldRestart = false;
        this.retryNumber = 0;
        // INIT
        this.addOnOpenHandler = function (onOpen) {
            _this.onOpen = onOpen;
        };
        this.addOnMessageHandler = function (onMessage) {
            _this.onMessage = onMessage;
        };
        this.addOnCloseHandler = function (onClose) {
            _this.onClose = onClose;
        };
        this.addOnErrorHandler = function (onError) {
            _this.onError = onError;
        };
        this.onCloseHandler = function (event) {
            _this.debug("socket-client", "onClose", event);
            if (_this.onClose) {
                _this.onClose(event);
            }
            if (_this.shouldRestart) {
                _this.connect();
                return;
            }
            if (!_this.shouldClose) {
                _this.reconnect();
                return;
            }
        };
        this.url = url;
        this.protocols = protocols || undefined;
        this.options = options ? __assign(__assign({}, this.options), options) : this.options;
    }
    // HELPERS
    WebSocketClient.prototype.getCurrentState = function () {
        var state = null;
        if (this.webSocket) {
            state = constants.STATES[this.webSocket.readyState];
        }
        return state;
    };
    WebSocketClient.prototype.getBinaryType = function () {
        var binaryType = null;
        if (this.webSocket) {
            binaryType = constants.BINARY_TYPES[this.webSocket.binaryType];
        }
        return binaryType;
    };
    WebSocketClient.prototype.getBufferedAmount = function () {
        var bufferedAmount = null;
        if (this.webSocket) {
            bufferedAmount = this.webSocket.bufferedAmount;
        }
        return bufferedAmount;
    };
    WebSocketClient.prototype.getExtensions = function () {
        var extensions = null;
        if (this.webSocket) {
            extensions = this.webSocket.extensions;
        }
        return extensions;
    };
    WebSocketClient.prototype.getProtocol = function () {
        var protocol = null;
        if (this.webSocket) {
            protocol = this.webSocket.protocol;
        }
        return protocol;
    };
    WebSocketClient.prototype.getUrl = function () {
        var url = null;
        if (this.webSocket) {
            url = this.webSocket.url;
        }
        return url;
    };
    WebSocketClient.prototype.debug = function (idn, message, data) {
        if (this.options.debug) {
            console.log("[" + idn + "] " + message, data);
        }
    };
    // LIFE CYCLE
    WebSocketClient.prototype.connect = function () {
        var _this = this;
        this.shouldClose = false;
        if (this.protocols) {
            this.webSocket = new WebSocket(this.url, this.protocols);
        }
        else {
            this.webSocket = new WebSocket(this.url);
        }
        this.webSocket.onopen = function (event) { return _this.onOpenHandler(event); };
        this.webSocket.onmessage = function (event) { return _this.onMessageHandler(event); };
        this.webSocket.onclose = function (event) { return _this.onCloseHandler(event); };
        this.webSocket.onerror = function (event) { return _this.onErrorHandler(event); };
    };
    WebSocketClient.prototype.onOpenHandler = function (event) {
        this.debug("socket-client", "onOpen", event);
        this.retryNumber = 0;
        if (this.onOpen) {
            this.onOpen(event);
        }
    };
    WebSocketClient.prototype.onMessageHandler = function (event) {
        this.debug("socket-client", "onMessage", event);
        if (this.onMessage) {
            var message = event.data;
            if (this.options.parsedMessage) {
                try {
                    message = JSON.parse(message);
                }
                catch (e) { }
            }
            this.onMessage(message, event);
        }
    };
    WebSocketClient.prototype.onErrorHandler = function (event) {
        this.debug("socket-client", "onError", event);
        if (this.onError) {
            this.onError(event);
        }
        this.close(true);
    };
    WebSocketClient.prototype.send = function (data) {
        if (this.webSocket) {
            var stringifiedData = null;
            try {
                stringifiedData = JSON.stringify(data);
            }
            catch (e) {
                return false;
            }
            this.webSocket.send(stringifiedData);
            return true;
        }
        return false;
    };
    WebSocketClient.prototype.restart = function () {
        this.shouldRestart = true;
        this.close();
    };
    WebSocketClient.prototype.reconnect = function () {
        var _this = this;
        var _a = this.options, maxNumber = _a.reconnectRetryMaxNumber, reconnectRetryTimeout = _a.reconnectRetryTimeout, shouldReconnect = _a.shouldReconnect;
        if (shouldReconnect && reconnectRetryTimeout) {
            if (maxNumber && this.retryNumber > maxNumber) {
                return;
            }
            this.retryNumber++;
            setTimeout(function () {
                _this.connect();
            }, reconnectRetryTimeout);
        }
    };
    WebSocketClient.prototype.close = function (reconnect) {
        if (this.webSocket) {
            this.shouldClose = !reconnect;
            this.webSocket.close();
        }
    };
    return WebSocketClient;
}());
exports.default = WebSocketClient;
});

var __pika_web_default_export_for_treeshaking__ = /*@__PURE__*/getDefaultExportFromCjs(dist);

export default __pika_web_default_export_for_treeshaking__;
